import { EmbeddedRecordsMixin } from '@warp-drive/legacy/serializer/rest';
import PostsSerializer from './base';
import { isEmpty } from '@ember/utils';

export default class Communitynotice extends PostsSerializer.extend(
  EmbeddedRecordsMixin,
) {
  normalize(modelClass, resourceHash) {
    // Default isPinned to false when the value is omitted from the payload.
    if (isEmpty(resourceHash.isPinned)) {
      resourceHash.isPinned = false;
    }

    return super.normalize(...arguments);
  }

  attrs = {
    mediaIds: { serialize: 'ids' },
  };

  payloadKeyFromModelName(modelName) {
    return super
      .payloadKeyFromModelName(modelName)
      .replace('communitynotice', 'post');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(
      key.replace('post', 'communitynotice'),
    );
  }
}
